import { ModelValidation } from "@/models/modelvalidation";
export interface IServiceKey {
    uuid?: string | null;
    name?: string | null;
    description?: string | null;
    key?: string | null;
}

export class ServiceKey extends ModelValidation {
    public uuid!: string | null;
    public name!: string | null;
    public description!: string | null;
    public key!: string | null;

    constructor(servicekey: IServiceKey | any) {
        super();
        if (!servicekey) {
            throw new Error("Cannot construct User from falsey IServiceKey");
        }

        this.uuid = servicekey.uuid;
        this.name = servicekey.name;
        this.description = servicekey.description;
        this.key = servicekey.key;
    }

    public static empty(): ServiceKey {
        return new ServiceKey({});
    }

    public toNewServiceKeyDto(): IServiceKey | any {
        return {
             name: this.name,
             description: this.description
        };
    }

    public toUpdateServiceAccountDto(): IServiceKey {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewServiceKeyDto();
        result.uuid = this.uuid;
        return result;
    }
}
